import axios from 'axios';
import { AUTH } from '../tools/ApiRoutes';

// URLs que NO deben incluir el interceptor de autenticación
const AUTH_EXCLUDED_URLS = [
    AUTH.login,
    AUTH.refresh,
    AUTH.loginWindows,
    AUTH.ENCRIPTACION,
    AUTH.GetDataID,
    // Agregar más URLs que no requieran autenticación
];

let interceptorsConfigured = false;

/**
 * Limpia la URL (quita querystring)
 * @param {string} url
 * @returns {string}
 */
const cleanUrl = (url = '') => {
    return url.split('?')[0];
};

/**
 * Verifica si una URL debe excluirse del interceptor de autenticación
 * @param {string} url - URL de la petición
 * @returns {boolean}
 */
const isAuthExcluded = (url = '') => {
    const path = cleanUrl(url);
    return AUTH_EXCLUDED_URLS.some((excludedUrl) => {
        if (!excludedUrl) return false;
        return path.endsWith(excludedUrl);
    });
};

/**
 * Obtiene los datos de autenticación del localStorage
 * @returns {object|null}
 */
const getAuthData = () => {
    try {
        const accessToken = localStorage.getItem('accessToken');
        if (!accessToken) return null;

        const tokenData = JSON.parse(accessToken);

        // También obtenemos los datos del usuario si están disponibles
        const userData = localStorage.getItem('user');
        let userInfo = {};

        if (userData) {
            try {
                userInfo = JSON.parse(userData);
            } catch (e) {
            }
        }

        return {
            user: tokenData.user,
            login: tokenData.user, // En tu caso, el login es el user
            token: tokenData.token,
            refreshToken: tokenData.refreshToken,
            expirationDate: tokenData.expirationDate,
            // Información adicional del usuario si está disponible
            userInfo,
        };
    } catch (error) {
        return null;
    }
};

/**
 * Configura los interceptors de Axios
 */
const setupInterceptors = () => {
    if (interceptorsConfigured) return;
    interceptorsConfigured = true;

    // Request Interceptor
    axios.interceptors.request.use(
        (config) => {
            // Verificar si la URL debe excluirse
            if (isAuthExcluded(config.url)) {
                return config;
            }

            const authData = getAuthData();

            if (authData && authData.token) {
                // Solo agregar Authorization header
                config.headers = config.headers || {};
                config.headers.Authorization = `Bearer ${authData.token}`;
            } else {
            }

            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // Response Interceptor
    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            const { response, config } = error;

            const isExcludedAuthRequest = isAuthExcluded(config?.url);

            // Manejar errores de autenticación, excepto endpoints públicos como login.
            if ((response?.status === 401 || response?.status === 403) && !isExcludedAuthRequest) {

                // Limpiar almacenamiento local
                localStorage.removeItem('accessToken');
                localStorage.removeItem('user');
                localStorage.removeItem('Menu');
                localStorage.removeItem('selectData');

                // Redirigir al login (ajusta la ruta según tu aplicación)
                if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
                    window.location.href = '/';
                }
            }

            return Promise.reject(error);
        }
    );
};

/**
 * Instancia de Axios configurada (opcional, para casos específicos)
 */
const apiClient = axios.create();

// Configurar interceptors al importar el módulo
setupInterceptors();

export { setupInterceptors, apiClient };
export default axios;
